// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JCQvAhMXbp4jauyHsjsA {
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  padding: 20px;
  margin: auto;
}

.zCFQ8W8uZZDwatqMGAFJ {
  display: inline-flex;
  padding: 0;
}

.ifB8esvDdlgAa_PzU0Xe {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(1px);
  z-index: 10;
}

.PTFItXZ3qOG7ENc7QqoD {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  z-index: 9999;
}

.bIiHyhLi1NNAAomPqy49 {
  color: var(--text-tertiary);
  font-size: var(--body-regular);
}

.Q9T73sZpuUG6k2WBTQjg {
  border: 4px solid var(--loader-color, rgba(0, 0, 0, 0.1));
  border-top: 4px solid var(--brand-primary-bg, #1976d2);
  border-radius: 50%;
  animation: GvCiHcqyf12VMIlPgzeh 1s linear infinite;
}

.FZNJfG5wdE7EsRPRBiog {
  width: 14px;
  height: 14px;
  border-width: 2px;
}
.Lkchw3JtwquLZ4asQTch {
  width: 20px;
  height: 20px;
  border-width: 3px;
}
.pNzSczedxuYnyYnoo8l0 {
  width: 32px;
  height: 32px;
  border-width: 4px;
}
.IU8s_Qdcq7E_2basCmEd {
  width: 48px;
  height: 48px;
  border-width: 5px;
}

@keyframes GvCiHcqyf12VMIlPgzeh {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LoadingSpinner/loader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,yDAAyD;EACzD,sDAAsD;EACtD,kBAAkB;EAClB,kDAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".loader {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  margin: auto;\n}\n\n.inline {\n  display: inline-flex;\n  padding: 0;\n}\n\n.overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.65);\n  backdrop-filter: blur(1px);\n  z-index: 10;\n}\n\n.fullscreen {\n  position: fixed;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.7);\n  z-index: 9999;\n}\n\n.label {\n  color: var(--text-tertiary);\n  font-size: var(--body-regular);\n}\n\n.loaderInner {\n  border: 4px solid var(--loader-color, rgba(0, 0, 0, 0.1));\n  border-top: 4px solid var(--brand-primary-bg, #1976d2);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.sizeXs {\n  width: 14px;\n  height: 14px;\n  border-width: 2px;\n}\n.sizeSm {\n  width: 20px;\n  height: 20px;\n  border-width: 3px;\n}\n.sizeMd {\n  width: 32px;\n  height: 32px;\n  border-width: 4px;\n}\n.sizeLg {\n  width: 48px;\n  height: 48px;\n  border-width: 5px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `JCQvAhMXbp4jauyHsjsA`,
	"inline": `zCFQ8W8uZZDwatqMGAFJ`,
	"overlay": `ifB8esvDdlgAa_PzU0Xe`,
	"fullscreen": `PTFItXZ3qOG7ENc7QqoD`,
	"label": `bIiHyhLi1NNAAomPqy49`,
	"loaderInner": `Q9T73sZpuUG6k2WBTQjg`,
	"spin": `GvCiHcqyf12VMIlPgzeh`,
	"sizeXs": `FZNJfG5wdE7EsRPRBiog`,
	"sizeSm": `Lkchw3JtwquLZ4asQTch`,
	"sizeMd": `pNzSczedxuYnyYnoo8l0`,
	"sizeLg": `IU8s_Qdcq7E_2basCmEd`
};
export default ___CSS_LOADER_EXPORT___;
